module.exports = __webpack_public_path__ + "img/top_game.ddede6da.jpg";